import { render, staticRenderFns } from "./page_heading.vue?vue&type=template&id=cd1e1838"
import script from "./page_heading.vue?vue&type=script&lang=js"
export * from "./page_heading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports